<mat-icon class="adf-datatable-selected" *ngIf="context.row.isSelected" svgIcon="selected"></mat-icon>

<img *ngIf="!context.row.isSelected"
     class="adf-datatable-center-img-ie"
     src="{{ getThumbnail(context) }}"
     [alt]="getToolTip(context)"
     [matTooltip]="getToolTip(context)">
